import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
export const ProviderConfigSectionSchema = z.enum(['ocr_ml', 'advanced']);
export const ProviderConfigSectionQuerySchema = z.object({
    section: ProviderConfigSectionSchema,
});
export const ProviderConfigSectionResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        section: ProviderConfigSectionSchema,
        config: z.record(z.string(), z.unknown()),
    }),
});
export const SetProviderConfigRequestSchema = z.object({
    section: ProviderConfigSectionSchema,
    key: z.string().min(1),
    value: z.unknown(),
    encrypt: z.boolean().default(false),
});
export const SetProviderConfigSectionRequestSchema = z.object({
    section: ProviderConfigSectionSchema,
    values: z.record(z.string(), z.unknown()),
    sensitiveKeys: z.array(z.string()).default([]),
});
export const ProviderSystemInfoResponseSchema = z.object({
    database: z.object({
        host: z.string(),
        port: z.number(),
        name: z.string(),
        ssl: z.boolean(),
        maxConnections: z.number(),
        connectionTimeout: z.number(),
        idleTimeout: z.number(),
        statementTimeout: z.number(),
    }),
});
//# sourceMappingURL=provider-config.schemas.js.map